import {readGridDensity} from '../shared/components/grid-density-control/grid-density-control.component';
import {AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Observable, from, Subscription, Subject} from "rxjs";
import { debounceTime, delay, map, filter } from 'rxjs/operators';

 import {PlaylistsService}  from "../shared/services/playlists.service";
  
import { NbDialogService,NbGlobalPosition, NbToastrService } from '@nebular/theme';
 import { NbMenuService } from '@nebular/theme';
  import { GoogleAnalyticsService } from '../@core/utils/analytics.service';


@Component({
  selector: 'app-overview-playlist-page', 
  templateUrl: './overview-playlist-page.component.html',
  styleUrls: ['./overview-playlist-page.component.scss'],
  
})
export class OverviewPlaylistPageComponent implements OnInit, OnDestroy, AfterViewInit{

  // Cards per row, as a ceiling - the grid drops a column by itself rather than
  // squeezing cards below a readable width.
  colsKey: string = 'livestream:playlists:cols'
  cols: number = readGridDensity(this.colsKey)

 
  

  isRoot: boolean = true;
  @ViewChild('deleteModal') deleteModal: any;
   
  pending = false;
  createSub$: Subscription; 
  removeSub$: Subscription;
   fetchLoading: boolean = true;
  playlists$: Subscription;
  showControls: boolean = false
  playlistToDelete: any = null
  removeLoading:boolean = false
//  watchersChanged$: Subject<any> = new Subject();
// watchersChangedFn: any
     menuSub$:any;
 
  playlists: any[] 

  constructor(  private playlistsService: PlaylistsService,  
 
    private dialogService: NbDialogService,
    private toastrService: NbToastrService,
private nbMenuService: NbMenuService,
public gAnalytics: GoogleAnalyticsService,
    ){ 
  }
   

  ngOnInit() { 
  this.playlists$ = this.playlistsService.fetch().subscribe((playlists: any[])=>{
 
      this.playlists = playlists
	 
      this.fetchLoading = false;  
      //
     },()=>{
      this.fetchLoading = false
      this.toastrService.show(``,'Сталася помилка завантаження',{
        status: 'danger',
        position: <NbGlobalPosition>'bottom-end'
      })
    })   


	

 		if(this.menuSub$){
	      this.menuSub$.unsubscribe()
	   	 }
		this.menuSub$ =	  this.nbMenuService.onItemClick()
		      .pipe(
 			filter(({ tag }) => tag === 'playlist-menu'),
			 map(({ item }) => item)
		      )
		      .subscribe( (item : any) => {this.onMenuClick(item.cmd, item.item);  }); 
 
  }





   onMenuClick(cmd, playlist){ 
	if(cmd === 'remove') { this.playlistToDelete = playlist; this.openRemoveModal();   return;}



  }


  openRemoveModal() {
    
    this.dialogService.open(this.deleteModal,{hasScroll: true} )
  
    
  }
  
  



  removeSelectedStream(ref){
    ref.close()
    this.removeStream(this.playlistToDelete)

  }

 
 
 
  createStream(){

    this.createSub$ = this.playlistsService.create().subscribe((playlist: any)=>{


      this.toastrService.show(`Плейлист "${playlist.title}" створено`,'Створення плейлиста',{
        status: 'success',
	position: <NbGlobalPosition>'bottom-end'
      })
 
        this.playlists.unshift(playlist)

	  this.gAnalytics.trackEvent('Add_playlist') 
    },()=>{
      
      this.toastrService.show(``,'Сталася помилка',{
        status: 'danger',
        position: <NbGlobalPosition>'bottom-end'
      })
    })

  }

 


  removeStream(playlist: any){
    

      if(this.removeSub$){
        this.removeSub$.unsubscribe()
      }

	this.removeLoading = true	

    this.removeSub$ = this.playlistsService.delete(playlist._id).subscribe(()=>{
      this.playlistToDelete = null

     this.toastrService.show(`Плейлист "${playlist.title}" видалено`,'Видалення плейлиста',{
      status: 'danger',
	position: <NbGlobalPosition>'bottom-end'
    })
      this.playlists = this.playlists.filter(s => s._id !== playlist._id)
    },()=>{
	 this.toastrService.show(`Сталася помилка при видаленні`,'Видалення плейлиста',{
      status: 'danger',
	position: <NbGlobalPosition>'bottom-end'
    })
	this.removeLoading = false  
	},()=>{
	

	this.removeLoading = false  
	

	})
  }

  
  ngAfterViewInit() {
    }
 
   ngOnDestroy() {
//     this.modal.destroy()
     if(this.createSub$){
       this.createSub$.unsubscribe()
     }

     if(this.playlists$){
      this.playlists$.unsubscribe()
    }

    if(this.removeSub$){
      this.removeSub$.unsubscribe()
    }
 

 if(this.menuSub$){
	      this.menuSub$.unsubscribe()
	   	 } 

   }
  
}
